/* eslint-disable no-useless-escape */
/* eslint-disable eqeqeq */
/* eslint-disable react/style-prop-object */
/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import { Form } from 'react-form';
import { required } from '../../utils/validation';
import { removeNonPrintableCharacters } from '../../utils/misc';

import {
    Input,
    Textarea,
} from '../Form';

class EditTeamTennisClubForm extends Component {
    constructor(props) {
        super(props);

        this.handlePlayerSelect = this.handlePlayerSelect.bind(this);
    }

    handlePlayerSelect(player, index) {
        console.log('handlePlayerSelect', player, index);
        const members = [...this.props.members];
        if (typeof player === 'object') {
            members[index] = player;
        } else if (typeof player === 'string') {
            members[index] = {
                email: player,
            };
        }
        console.log('members', members);
        this.props.setMembers(members);
    }

    render() {
        const {
            handleSubmit,
            submitting,
        } = this.props;

        const { defaultValues } = this.props;

        const isEmpty = value => value === undefined || value === null || value === '';

        const url = (value) => {
            let error;
            if (!isEmpty(value)) {
                const newCheckUrl = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gm.test(value.trim());
                if (!newCheckUrl) {
                    error = 'This does not appear to be a valid url';
                }
            }
            return error;
        };

        const onKeyPress = (event) => {
            if (event.key === 'Enter' && event.target.type !== 'submit' && event.target.type !== 'button' && event.target.id !== 'about') {
                event.preventDefault();
            }
        };

        return (
            <Form onSubmit={values => handleSubmit({ values })} defaultValues={defaultValues}>
                {({ submitForm, setValue }) => {
                    return (
                        <form onSubmit={submitForm} id="createClubForm" onKeyPress={onKeyPress} data-testid="club-edit.team-tennis-form.form">
                            <div className="container">
                                <div className="row">
                                    <div className={`offset-md-3 col-md-6`}>
                                        <Input
                                            label="Name"
                                            id="clubName"
                                            field="clubName"
                                            type="text"
                                            placeholder={'Ex. Palo Alto Tennis Group'}
                                            validate={required}
                                            disabled={true}
                                            onChange={(e) => {
                                                setValue('clubName', removeNonPrintableCharacters(e));
                                            }}
                                        />
                                        <Textarea
                                            label="About (Optional)"
                                            description="Give a short description of your team that will appear on your team page"
                                            id="about"
                                            field="about"
                                            rows="5"
                                            placeholder="Ex. Lorem ispum..."
                                        />
                                        <Input
                                            label="Registration"
                                            description={`Add a link to the player registration page here`}
                                            id="website"
                                            field="website"
                                            type="text"
                                            placeholder="https://example.com"
                                            validate={url}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="container buttons">
                                <div className="row">
                                    <div className="col-md-6 offset-md-3">
                                        <div className="row">
                                            <div className="col-md-6 mb16">
                                                <button
                                                    onClick={() => {
                                                        window.location.href = this.props.profileRedirectPath;
                                                    }}
                                                    type="button"
                                                    className="btn btn-default btn-xl text-uppercase btn-block"
                                                    data-testid="club-edit.team-tennis-form.cancel-btn"
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                            <div className="col-md-6 mb16">
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary btn-xl text-uppercase btn-block"
                                                    disabled={submitting}
                                                    data-testid="club-edit.team-tennis-form.submit-btn"
                                                >
                                                    {submitting
                                                        ? ('Updating...')
                                                        : ('Update')}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </form>
                    );
                }}
            </Form>
        );
    }
}

EditTeamTennisClubForm.defaultProps = {
    profileRedirectPath: '/clubs',
};

export default EditTeamTennisClubForm;
